<template lang="html">
  <div class="content clue">
    <clueFilter :type="0" v-on:filterData="getFilters" />
    <div class="list">
      <div class="handles"></div>
      <skeleton v-show="waiting"></skeleton>
      <listItem v-show="!waiting" :list="list" :type="2" :sort="true" v-on:getSort="getFilters" :showCreate="showCreate" :enablePush="enablePush" />
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
  </div>
</template>

<script>
import clueFilter from '@components/clueFilter'
import listItem from '@components/listItem'
import common from '@common/common'
import {apis} from '@common/config'
import pages from '@components/pages'
import skeleton from "@components/skeleton";

export default {
  components: { clueFilter, listItem, pages, skeleton },
  data() {
    return {
      controller: null,
      waiting: true,
      list: null,
      enablePush: false,
      filterOptions: {},
      searchOptions: {},
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      showCreate: false,
      isChrome: true
    }
  },
  watch: {
    $route: {
      deep: true,
      handler: function(n, o) {
        // 监听路由变化重置请求参数
        const nid = n.params.id
        const oid = o.params.id
        if (nid !== oid) {
          this.searchOptions = {}
          this.filterOptions = {}
          this.page.pageIndex = 1
        }
      }
    }
  },
  methods: {
    getFilters(data) {
      // 获取过滤条件数据
      // this.filterOptions = data
      this.filterOptions = Object.assign({}, this.filterOptions, data)
      this.page.pageIndex = 1
      this.getList()
    },
    getList(keyWord) {
      if (this.controller) {
        this.controller.abort(); // 终止之前的请求
      }

      this.controller = new AbortController(); // 创建新的 AbortController
      const signal = this.controller.signal; // 获取信号

      // 获取列表数据
      this.waiting = true;
      const id = this.$route.params.id

      const info = {
        idstring: id,
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        sort_by: '',
        search_option: '',
        key_words: '',
        source_pid: '',
        source_sid: '',
        days: '',
        tags: '',
        has_file: '',
        start: '',
        end: ''
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.clue_common, {data: info,signal: signal})
      .then((res) => {
        if (res) {
          res.list.forEach(el => {
            el.showPushBtns = false;
            el.showThreePoint = false;
          });
          this.list = res.list
          this.generateSearchs(res.params.top_search.option.list)
          this.$set(this.page, 'pageCount', common.calculatePage(res.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', res.page.row_count - 0)
          this.showCreate = res.has_add_role
          this.enablePush = !!res.reportExist

          this.$nextTick(() => {
            this.waiting = false;
          })
        }
      })
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      console.log(d)
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    }
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    const selectedTag = this.$route.params.tag || ''
    this.filterOptions.tags = selectedTag

    this.getList('noKeyWord')
    var agent = navigator.userAgent.toLowerCase();
    if(agent.indexOf("chrome") > 0) {
      this.isChrome = true
    }else{
      this.isChrome = false
    }

    this.$AiMessage()
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';
  .content.clue {
    display: flex;
    flex-direction: column;

    &>.clueFilter {
      margin-bottom: 30px;
    }
  }

  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    .boxOuter;
    padding-bottom: 50px;
  }
</style>
